import React, { useState, useEffect } from "react";
import { Field } from "react-final-form";
import {
  FORM_FIELDS_USER_TWO,
  CONTINENTS,
} from "../../constants";

import "./RegisterEmailComponent.css";

export const RegisterEmailComponent = (props) => {
  const submitEmail = (e) => {
    return e.key === "Enter"
      ? [
          e.preventDefault(),
          props.handleEmailSubmit(e.target.value)
        ]
      : null;
  };


  const submitDifferentEmail = (e) => {
    return e.key === "Enter"
      ? [
          e.preventDefault(),
          props.handleDifferentEmailSubmit(e.target.value)
        ]
      : null;
  };


  const submitCompanyName = (e) => {
    console.log("Companny name: "+e.target.value);
    return e.key === "Enter"
      ? [
          e.preventDefault(),
          props.handleCompanyNameSubmit(e.target.value)
        ]
      : null;
  };

  const [differentEmail, setDifferentEmail] = useState(false);

  const checkDifferentEmail = (e) => {
    if (e.target.checked) {
      console.log(e.target.checked);
      setDifferentEmail(true);
    } else {
      setDifferentEmail(false);

    }
  };

  return (
    <div className="RegisterEmailComponent registration-page-step">
      <h3 className="registration-page-step__title">
        Welcome to 1stopvat, please enter your email Address
      </h3>

      <div className="registration-page-step__fields-wrapper">
        <div className="registration-input__wrapper">
          <table width={745}>
            <tr>
              <td>
          <div className="field-item email">
            <p className="title">Email</p>

            {props.emailValidationStatus === false && (
              <span className="field-error-message">Email is not valid</span>
            )}

            {props.emailErrorMessage && (props.emailErrorMessage.length > 1) && (
              <span className="field-error-message">{props.emailErrorMessage}</span>
            )}

            <Field
              className={
                "registration-input register-input " +
                ((props.emailValidationStatus === false && "field-error") || "")
              }
              name="email"
              type="text"
              placeholder={props.emailContent.placeholder}
              key={props.emailContent.name}
              component="input"
              onBlur={props.removeEmailError}
              onKeyPress={(e) => submitEmail(e)}
            />

          </div>
          </td>
          <td>
          
          {differentEmail ? (
                        <div className="field-item email">
                        <p className="title">Contact email</p>
            
                        {props.emailValidationStatus === false && (
                          <span className="field-error-message">Email is not valid</span>
                        )}
            
                        <Field
                          className={
                            "registration-input register-input "
                          }
                          name="contactEmail"
                          type="text"
                          placeholder={props.contactEmail.placeholder}
                          key={props.contactEmail.name}
                          component="input"
                          onKeyPress={(e) => submitDifferentEmail(e)}
                        />
            
                      </div>
            ) : ""}

          </td>
          </tr>
          </table>

          
          <div className="registration-page-step__fields-wrapper">

          <label className="checkbox-label">
          <Field
          name="useDifferentEmail"
          component="input"
          type="checkbox"
          value="useDifferentEmail"
          onClick={(e) => checkDifferentEmail(e)}

        />

              &nbsp;&nbsp;&nbsp;Use different contact email?
            </label>
            </div>

          {props.companyNameValidationStatus === false && (
              <span className="field-error-message">Email is not valid</span>
            )}

                   <div className="field-item companyName">
            <p className="title">Copany name</p>

            <Field
              className={
                "registration-input register-input " +
                ((props.companyNameValidationStatus === false && "field-error") || "")
              }
              name="companyName"
              type="text"
              placeholder={props.companyName.placeholder}
              key={props.companyName.name}
              component="input"
              onKeyPress={(e) => submitCompanyName(e)}
            />
          </div> 

          <div className="field-item country_of_incorporation">
            <p className="title">{FORM_FIELDS_USER_TWO.countryincorporation.title}</p>
            <Field
              name={FORM_FIELDS_USER_TWO.countryincorporation.name}
              defaultValue={props.countryincorporation && props.countryincorporation}
            >
              {({ input }) => {
                const { onChange } = input;
                const mergedOnChange = (e) => onChange(e);
                const newInput = { ...input, onChange: mergedOnChange };

                return (
                  <select {...newInput} className="registration-input">

                    {/* Placeholder */}
                    <option disabled value="" key={1}>
                      {FORM_FIELDS_USER_TWO.countryincorporation.placeholder}
                    </option>

                    {/* Values */}
                    {Object.entries(props.countries).map(
                      ([item, continentValue]) => {
                        return (
                          <optgroup label={CONTINENTS[item]} key={item}>
                            {continentValue.map((country) => (
                              <option value={country.id} key={country.id}>
                                {country.name}
                              </option>
                            ))}
                          </optgroup>
                        );
                      }
                    )}
                  </select>
                );
              }}
            </Field>
          </div>
        </div>
      </div>

      <div className="registration-page-step__button-wrapper">
        <button
          type="button"
          className="registration-input registration-input__button"
          onClick={ () => props.handleEmailSubmit(props.values["email"])}
          disabled={((props.values.country_of_incorporation === undefined ? true : false) 
            || ((props.values.companyName === undefined || props.values.companyName == "") ? true : false))
            || ((differentEmail && props.values.contactEmail === undefined ) ? true : false)
          
          }
        >
          proceed
        </button>
      </div>
    </div>
  );
};
